/*
 * File: UISnackbar.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:  Handles showing a material ui snackbar
 */
import React from "react";
import PropTypes from "prop-types";
import Snackbar from "@material-ui/core/Snackbar";
import RenderSnackbarContent from "./RenderSnackbarContent";

class UISnackbar extends React.Component {
  state = { open: false, dismissed: false };

  /**
   * We need to show the snackbar if they click submit for errors or success
   * but we also want to hide it if the user clicks the snackbar to dismiss it.
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    // only show the snackbar if it has not been dismissed and the props ask it to be open
    if (nextProps.open === true && prevState.dismissed === false) {
      prevState.open = true;
    } else {
      // reset dismissed so if they submit we show the snackbar
      prevState.dismissed = false;
    }
    return null;
  }

  /**
   * Called when the snackbar has been clicked so we can dismiss it
   */
  handleClose = () => {
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
    this.setState({ open: false, dismissed: true });
  };

  render() {
    let { message, variant } = this.props;
    let { open } = this.state;
    let vertical = this.props.vertical || "bottom";

    return (
      <Snackbar
        anchorOrigin={{
          vertical: vertical,
          horizontal: "center"
        }}
        onClick={this.handleClose}
        open={open}
        autoHideDuration={4000}
      >
        <RenderSnackbarContent variant={variant} message={message} />
      </Snackbar>
    );
  }
}

UISnackbar.propTypes = {
  message: PropTypes.string,
  variant: PropTypes.oneOf(["error", "success"]).isRequired,
  vertical: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};

export default UISnackbar;
